/* adv.js · Alyviu Insider advertorial: scroll strip, testimonial carousel, UTM passthrough */

/* 0. Page language from <html lang> (the layout sets "ja" on *-jp templates). Strings used by the
      checkout buttons (4) and the shipping row (8). English stays the default. */
var advT = (function () {
  var ja = (document.documentElement.lang || '').slice(0, 2) === 'ja';
  return ja ? {
    lang: 'ja', locale: 'ja-JP', dateOpts: { month: 'long', day: 'numeric', weekday: 'short' },
    opening: '安全な決済ページを開いています…', shipsBy: '<strong>{date}</strong>までに発送', shipTo: '{country}への送料'
  } : {
    lang: 'en', locale: 'en-US', dateOpts: { weekday: 'short', month: 'short', day: 'numeric' },
    opening: 'Opening secure checkout…', shipsBy: 'Ships by <strong>{date}</strong>', shipTo: 'shipping to {country}'
  };
})();
(function () {
  // 1. Carry ad parameters (utm_*, fbclid...) to the product page links.
  var qs = window.location.search.replace(/^\?/, '');
  if (qs) {
    var params = new URLSearchParams(qs);
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        params.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  // 2. Fixed masthead: keep the article offset by the real header height.
  var fixed = document.querySelector('[data-adv-fixed]');
  if (fixed) {
    var setHead = function () { document.documentElement.style.setProperty('--adv-head', fixed.offsetHeight + 'px'); };
    setHead();
    window.addEventListener('resize', setHead);
    window.addEventListener('load', setHead);
    if (window.ResizeObserver) { new ResizeObserver(setHead).observe(fixed); }
  }

  // 3. Testimonial carousel.
  document.querySelectorAll('[data-adv-carousel]').forEach(function (root) {
    var track = root.querySelector('.adv-tst__track');
    var slides = track ? track.children : [];
    var dots = root.querySelectorAll('.adv-tst__dot');
    if (!track || slides.length < 2) return;
    var i = 0, timer = null, n = slides.length;
    var go = function (k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      root.setAttribute('data-index', i);
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    };
    var start = function () { stop(); timer = window.setInterval(function () { go(i + 1); }, 5000); };
    var stop = function () { if (timer) window.clearInterval(timer); timer = null; };
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); start(); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    go(0); start();
  });
})();

/* 4. Checkout buttons: put the bundle in the session cart and open checkout, so Shopify's
      conversion funnel sees the cart addition. One request in the usual case: cart/update.js sets
      the bundle quantity to exactly 1 and carries the adv_cta attribute; cart/clear.js only runs
      when the cart already had items (known from a background cart.js read at load). Feedback
      shows on tap. The href (cart permalink) is the fallback if a request fails or takes longer
      than 3 s. AddToCart goes to Meta through the alyviu-global listener.
   5. Mobile sticky bar: hide it while the offer cards are on screen.
   6. "View the product page" link: tags the cart with adv_cta=browse before leaving, so an order
      placed from the product page shows "browse" in its notes like the card tags. Leaves after
      0.8 s even if the cart does not answer. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var post = function (path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  };

  var cartCount = null;
  var readCart = function () {
    cartCount = null;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCount = c.item_count; })
      .catch(function () {});
  };
  if (document.querySelector('a[data-adv-checkout]')) readCart();

  var busy = function (a, on) {
    a.classList.toggle('is-loading', on);
    if (on) a.setAttribute('aria-busy', 'true'); else a.removeAttribute('aria-busy');
    if (!a.classList.contains('adv-btn')) return;
    if (on) {
      a.setAttribute('data-label', a.textContent);
      a.textContent = advT.opening;
    } else if (a.hasAttribute('data-label')) {
      a.textContent = a.getAttribute('data-label');
    }
  };

  // One checkout request at a time, across ALL buttons: a second tap on another card or button
  // while "Opening secure checkout…" is showing used to add the bundle twice (seen 16/out: a
  // 1+1 checkout at $59.80 = 2 units). The lock drops the extra tap; cart/update.js SETS the
  // quantity to 1 instead of adding, so even a repeated request can never end with 2.
  var inflight = false;
  var unlock = function () {
    inflight = false;
    document.querySelectorAll('a[data-adv-checkout].is-loading').forEach(function (a) { busy(a, false); });
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-adv-checkout]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (inflight || a.classList.contains('is-loading')) return;
    inflight = true;
    window.setTimeout(function () { if (!left) unlock(); }, 10000);
    busy(a, true);

    var variant = Number(a.getAttribute('data-variant'));
    var fallback = a.href;
    var tag = '';
    try { tag = new URL(fallback).searchParams.get('attributes[adv_cta]') || ''; } catch (err) {}

    document.dispatchEvent(new CustomEvent('alyviu:added-to-cart', {
      detail: { item: {
        variant_id: variant,
        product_title: a.getAttribute('data-title'),
        final_line_price: parseInt(a.getAttribute('data-price'), 10) || 0,
        quantity: 1
      } }
    }));

    left = false;
    var go = function (url) { if (left) return; left = true; window.location.href = url; };
    var timer = window.setTimeout(function () { go(fallback); }, 3000);
    var body = { updates: {} };
    body.updates[variant] = 1;
    if (tag) body.attributes = { adv_cta: tag };
    var ready = cartCount === 0 ? Promise.resolve() : post('cart/clear.js', {});
    ready
      .then(function () { return post('cart/update.js', body); })
      .then(function () { cartCount = 1; window.clearTimeout(timer); go(root + 'checkout'); })
      .catch(function () { window.clearTimeout(timer); go(fallback); });
  });
  var left = false;

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    left = false;
    unlock();
    readCart();
  });

  var sticky = document.querySelector('.adv-sticky');
  var startId = sticky && sticky.getAttribute('data-show-after');
  var startEl = startId && document.getElementById(startId);
  if (startEl) {
    var queued = false;
    var check = function () {
      queued = false;
      sticky.classList.toggle('is-waiting', startEl.getBoundingClientRect().top > window.innerHeight);
    };
    var queue = function () { if (!queued) { queued = true; window.requestAnimationFrame(check); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }
  var offers = document.querySelectorAll('[data-adv-offer]');
  if (sticky && offers.length && 'IntersectionObserver' in window) {
    var onScreen = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = onScreen.indexOf(en.target);
        if (en.isIntersecting && i < 0) onScreen.push(en.target);
        if (!en.isIntersecting && i > -1) onScreen.splice(i, 1);
      });
      sticky.classList.toggle('is-hidden', onScreen.length > 0);
    }, { threshold: 0.15 });
    offers.forEach(function (o) { io.observe(o); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-adv-browse]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var href = a.href, gone = false;
    var go = function () { if (!gone) { gone = true; window.location.assign(href); } };
    setTimeout(go, 800);
    post('cart/update.js', { attributes: { adv_cta: 'browse' } }).then(go, go);
  });
})();

/* 7. Copy guard: blocks copy, cut, text selection, the context menu, image dragging and the
   Ctrl/Cmd + C, X, A, S, U shortcuts. Left click is untouched, so links, offer cards and checkout keep working. */
(function () {
  var stop = function (e) { e.preventDefault(); };
  ['copy', 'cut', 'contextmenu', 'selectstart', 'dragstart'].forEach(function (t) { document.addEventListener(t, stop); });
  document.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && /^[cxasu]$/i.test(e.key)) e.preventDefault();
  });
})();

/* 8. Shipping row on the offer card: "Ships by <date>" (today + N days, skipping Sunday, visitor's
   local date) and the visitor's country with its flag, from Shopify's browsing context endpoint.
   Without a country the row keeps "tracked shipping" and no flag. */
(function () {
  var rows = document.querySelectorAll('[data-adv-ship]');
  if (!rows.length) return;
  rows.forEach(function (row) {
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(row.getAttribute('data-days'), 10) || 2));
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    var label = d.toLocaleDateString(advT.locale, advT.dateOpts);
    if (advT.lang === 'ja') label = label.replace('(', '（').replace(')', '）');
    var when = row.querySelector('[data-adv-ship-when]');
    if (when) when.innerHTML = advT.shipsBy.replace('{date}', label);
  });
  var apply = function (c) {
    if (!c || !c.handle || !c.name) return;
    var name = c.name;
    if (advT.lang !== 'en') {
      try { name = new Intl.DisplayNames([advT.lang], { type: 'region' }).of(c.handle) || c.name; } catch (e) {}
    }
    rows.forEach(function (row) {
      var flag = row.querySelector('[data-adv-ship-flag]');
      var to = row.querySelector('[data-adv-ship-to]');
      if (to) to.textContent = advT.shipTo.replace('{country}', name);
      if (flag) {
        flag.onload = function () { flag.hidden = false; };
        flag.alt = name;
        flag.src = 'https://cdn.shopify.com/static/images/flags/' + c.handle.toLowerCase() + '.svg';
      }
    });
  };
  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem('adv_country') || 'null'); } catch (e) {}
  if (cached) { apply(cached); return; }
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var c = j && j.detected_values && j.detected_values.country;
      if (!c) return;
      try { sessionStorage.setItem('adv_country', JSON.stringify(c)); } catch (e) {}
      apply(c);
    })
    .catch(function () {});
})();

/* 9. Local currency. Pages opt in with data-adv-usd on a price block (the USD amounts written in the copy).
      Mode A (Shopify Markets already switched the storefront currency): the kit and per-strap figures are
      copied from the cards (exact, rounded by Shopify) into the text, buttons and shipping line (shipping
      is converted with Shopify.currency.rate and marked with an approximate sign).
      Mode B (storefront still in USD, visitor in a country whose currency Shopify cannot charge, e.g. Brazil):
      the visitor's country comes from Shopify's browsing-context endpoint, the currency from the table below
      and the rate from open.er-api.com (daily). Every USD amount in the map is converted for display,
      including the cards, and the fx note under the cards says the card is charged in USD. */
(function () {
  var block = document.querySelector('[data-adv-usd]');
  if (!block) return;
  var SHOP = 'USD';
  var cur = (window.Shopify && window.Shopify.currency) || {};
  var map = {};
  block.getAttribute('data-adv-usd').split('|').forEach(function (kv) {
    var p = kv.split('='); if (p.length === 2) map[p[0].trim()] = p[1].trim();
  });
  var usdOf = function (t) { return parseFloat(String(t).replace(/[^\d.]/g, '')); };
  var swap = function (local) {
    var tokens = Object.keys(local).sort(function (a, b) { return b.length - a.length; });
    if (!tokens.length) return;
    var root = document.querySelector('main') || document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.nodeValue.indexOf('$') > -1) nodes.push(n); }
    nodes.forEach(function (node) {
      var v = node.nodeValue;
      tokens.forEach(function (t) { if (v.indexOf(t) > -1) v = v.split(t).join(local[t]); });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  };
  var fmt = function (amount, code, digits) {
    if (digits == null) digits = amount >= 50 ? 0 : 2;
    try {
      return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: code, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount);
    } catch (e) { return code + ' ' + amount.toFixed(digits); }
  };

  // ---- Mode A: Shopify switched the currency
  var prices = block.querySelectorAll('.adv-offer__price');
  if (cur.active && cur.active !== SHOP && prices.length && !/^\s*(US)?\$/.test(prices[0].textContent)) {
    var local = {};
    if (map.v1 && prices[0]) local[map.v1] = prices[0].textContent.trim();
    if (map.v2 && prices[1]) local[map.v2] = prices[1].textContent.trim();
    var subs = block.querySelectorAll('.adv-offer__sub');
    var per = function (el) { var m = el && el.textContent.match(/total\.\s*(.+?)\s+per strap/); return m ? m[1].trim() : null; };
    if (map.per1 && per(subs[0])) local[map.per1] = per(subs[0]);
    if (map.per2 && per(subs[1])) local[map.per2] = per(subs[1]);
    var rate = parseFloat(cur.rate);
    if (map.ship && rate > 0 && usdOf(map.ship) > 0) local[map.ship] = '\u2248' + fmt(usdOf(map.ship) * rate, cur.active);
    swap(local);
    return;
  }
  if (cur.active && cur.active !== SHOP) return;

  // ---- Mode B: display conversion by visitor country
  var CC = {BR:'BRL',AR:'ARS',CL:'CLP',CO:'COP',MX:'MXN',PE:'PEN',UY:'UYU',PY:'PYG',BO:'BOB',VE:'VES',DO:'DOP',GT:'GTQ',CR:'CRC',HN:'HNL',NI:'NIO',JM:'JMD',TT:'TTD',BS:'BSD',BB:'BBD',BZ:'BZD',GY:'GYD',SR:'SRD',HT:'HTG',
    CA:'CAD',GB:'GBP',IE:'EUR',AT:'EUR',BE:'EUR',CY:'EUR',DE:'EUR',EE:'EUR',ES:'EUR',FI:'EUR',FR:'EUR',GR:'EUR',HR:'EUR',IT:'EUR',LT:'EUR',LU:'EUR',LV:'EUR',MT:'EUR',NL:'EUR',PT:'EUR',SI:'EUR',SK:'EUR',
    CH:'CHF',NO:'NOK',SE:'SEK',DK:'DKK',IS:'ISK',PL:'PLN',CZ:'CZK',HU:'HUF',RO:'RON',BG:'BGN',RS:'RSD',UA:'UAH',TR:'TRY',IL:'ILS',RU:'RUB',KZ:'KZT',GE:'GEL',AM:'AMD',AZ:'AZN',
    AE:'AED',SA:'SAR',KW:'KWD',QA:'QAR',BH:'BHD',OM:'OMR',JO:'JOD',LB:'LBP',IQ:'IQD',EG:'EGP',MA:'MAD',DZ:'DZD',TN:'TND',NG:'NGN',GH:'GHS',KE:'KES',ZA:'ZAR',TZ:'TZS',UG:'UGX',ET:'ETB',MU:'MUR',
    IN:'INR',PK:'PKR',BD:'BDT',LK:'LKR',NP:'NPR',MV:'MVR',CN:'CNY',HK:'HKD',MO:'MOP',TW:'TWD',JP:'JPY',KR:'KRW',SG:'SGD',MY:'MYR',TH:'THB',VN:'VND',ID:'IDR',PH:'PHP',BN:'BND',KH:'KHR',LA:'LAK',MM:'MMK',MN:'MNT',
    AU:'AUD',NZ:'NZD',FJ:'FJD',PG:'PGK'};
  var convert = function (code, rate) {
    if (!code || code === SHOP || !(rate > 0)) return;
    var local = {};
    var digits = (usdOf(map.v1 || '0') * rate) >= 50 ? 0 : 2;   // same number of decimals on every amount of the page
    Object.keys(map).forEach(function (k) { var u = usdOf(map[k]); if (u > 0) local[map[k]] = fmt(u * rate, code, digits); });
    swap(local);
    var note = block.querySelector('[data-adv-fx-note]');
    if (note) {
      note.textContent = note.textContent.replace('[cur]', code).replace('[usd1]', map.v1 || '').replace('[usd2]', map.v2 || '');
      note.hidden = false;
    }
  };
  var withRate = function (code) {
    if (!code || code === SHOP) return;
    var c = null;
    try { c = JSON.parse(sessionStorage.getItem('adv_fx') || 'null'); } catch (e) {}
    if (c && c.cur === code && c.rate > 0 && Date.now() - c.ts < 12 * 3600 * 1000) { convert(code, c.rate); return; }
    fetch('https://open.er-api.com/v6/latest/USD').then(function (r) { return r.json(); }).then(function (j) {
      var rate = j && j.rates && j.rates[code];
      if (!(rate > 0)) return;
      try { sessionStorage.setItem('adv_fx', JSON.stringify({ ts: Date.now(), cur: code, rate: rate })); } catch (e) {}
      convert(code, rate);
    }).catch(function () {});
  };
  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem('adv_country') || 'null'); } catch (e) {}
  if (cached && cached.handle) { withRate(CC[String(cached.handle).toUpperCase()]); return; }
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var c = j && j.detected_values && j.detected_values.country;
      if (!c || !c.handle) return;
      try { sessionStorage.setItem('adv_country', JSON.stringify(c)); } catch (e) {}
      withRate(CC[String(c.handle).toUpperCase()]);
    })
    .catch(function () {});
})();

